<template>
    <div class="ui-content dashboard">
        <div class="page-user user">
            <v-tabs v-model="tab" background-color class="elevation-2 cust-tab" :centered="centered" :grow="grow"
                :vertical="vertical" :right="right"
                :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
                :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined" :icons-and-text="icons">
                <v-tabs-slider></v-tabs-slider>
                <v-tab key="Upcoming" :href="'#Upcoming'">Upcoming Tests</v-tab>
                <v-tab key="Live" :href="'#Live'">Live Tests</v-tab>
                <v-tabs-items :touchless="true" v-model="tab">
                    <v-tab-item key="Upcoming" :value="'Upcoming'">
                        <v-card class="mx-auto normal-card">
                            <div class="data-table-section prev-test-tb cat-44">
                                <v-data-table :key="`upcoming-table-${currentPage}`" :headers="headers" fixed-header
                                    :items="items" hide-default-header hide-default-footer
                                    class="elevation-2 cust-table">
                                    <template v-slot:header="{ props: { headers } }">
                                        <TableHeader :headers="headers" :onSortChange="onSortChange"
                                            :onHeaderAction="onHeaderAction" :orderBy="orderBy" />
                                    </template>
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td class="text-left">
                                                    <v-tooltip left content-class="cust-new-tooltip-bottom">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on">
                                                                {{ item.alt_test_name }}
                                                            </div>
                                                        </template>
                                                        <span>
                                                            <b> Target Exam: </b> {{ item.target_name }} <br />
                                                            <b>Test Pattern: </b> {{ item.omr_pattern_id ?
                                                            OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                                                        </span>
                                                    </v-tooltip>
                                                </td>
                                                <td class="text-center">{{ item.duration }}</td>
                                                <td class="text-left">
                                                    <div class="date-ui">
                                                        {{
                                                            getFormatedDate(
                                                                item.scheduled_start
                                                            )
                                                        }}
                                                    </div>
                                                    <div class="time-ui">
                                                        {{
                                                            getFormatedTime(
                                                                item.scheduled_start
                                                            )
                                                        }}
                                                    </div>
                                                </td>
                                                <td class="text-left">
                                                    <div class="date-ui">
                                                        {{
                                                            getFormatedDate(item.scheduled_end)
                                                        }}
                                                    </div>
                                                    <div class="time-ui">
                                                        {{
                                                            getFormatedTime(item.scheduled_end)
                                                        }}
                                                    </div>
                                                </td>
                                                <td class="text-left">
                                                    {{ item.target_name }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                                <div class="btm-test-prev-test text-right" v-if="tab == 'Live'">
                                    Click on a test name to start answering that test
                                </div>
                            </div>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item key="Live" :value="'Live'">
                        <v-card class="mx-auto normal-card">
                            <div class="data-table-section prev-test-tb cat-44">
                                <v-data-table :key="`live-table-${currentPage}`" :headers="headers" fixed-header
                                    :items="items" hide-default-header hide-default-footer
                                    class="elevation-2 cust-table">
                                    <template v-slot:header="{ props: { headers } }">
                                        <TableHeader :headers="headers" :onSortChange="onSortChange"
                                            :onHeaderAction="onHeaderAction" :orderBy="orderBy" />
                                    </template>
                                    <template v-slot:body="{ items }">
                                        <tbody>
                                            <tr v-for="item in items" :key="item.id">
                                                <td class="text-left rescheduletest" @click="gotoPastTest(item)">
                                                    <v-tooltip left content-class="cust-new-tooltip-bottom">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <div v-bind="attrs" v-on="on">
                                                                {{ item.alt_test_name }}
                                                            </div>
                                                        </template>
                                                        <span>
                                                            <b> Target Exam: </b> {{ item.target_name }} <br />
                                                            <b>Test Pattern: </b> {{ item.omr_pattern_id ?
                                                            OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                                                        </span>
                                                    </v-tooltip>
                                                </td>
                                                <td class="text-center">{{ item.duration }}</td>
                                                <td class="text-left">
                                                    <div class="date-ui">
                                                        {{
                                                            getFormatedDate(
                                                                item.scheduled_start
                                                            )
                                                        }}
                                                    </div>
                                                    <div class="time-ui">
                                                        {{
                                                            getFormatedTime(
                                                                item.scheduled_start
                                                            )
                                                        }}
                                                    </div>
                                                </td>
                                                <td class="text-left">
                                                    <div class="date-ui">
                                                        {{
                                                            getFormatedDate(item.scheduled_end)
                                                        }}
                                                    </div>
                                                    <div class="time-ui">
                                                        {{
                                                            getFormatedTime(item.scheduled_end)
                                                        }}
                                                    </div>
                                                </td>
                                                <td class="text-left">
                                                    {{ item.target_name }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-data-table>
                                <div class="btm-test-prev-test text-right" v-if="tab == 'Live'">
                                    Click on a test name to start answering that test
                                </div>
                            </div>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
        <div class="footer-btn">
            <div class="pull-left"></div>
            <div class="pull-right">
                <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
            </div>
        </div>
        <AlertBox :width="modalWidth" :onClose="onClose" :component="cComponent" :status="status"
            :data="alertBoxData" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
    name: "OnlineAITSTest",
    props: {
        tab: {
            type: String,
            default: null
        },
        value: {
            type: [String, Number],
            default: null
        }
    },
    mounted() {
        this.OMR_PATTERN = constants.OMR_PATTERN;
        this.checkSessionData();
        this.checkModuleAccess();
    },
    data() {
        return {
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            headers: [
                {
                    text: "Test Name",
                    class: "text-left",
                    value: "alt_test_name",
                    hideSort: true,
                },
                {
                    text: "Duration(mins)",
                    class: "text-center",
                    value: "duration",
                    hideSort: true,
                },
                {
                    text: "Start Date & Time",
                    class: "text-center",
                    value: "scheduled_start",
                    hideSort: false,
                },
                {
                    text: "End Date & Time",
                    class: "text-center",
                    value: "scheduled_end",
                    hideSort: false,
                },
                {
                    text: "Target Exam",
                    class: "text-left",
                    value: "target_exam",
                    hideSort: true,
                },
            ],
            items: [],
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            orderBy: {
                field: "test_name",
                order: "ASC"
            },
            status: false,
            alertBoxData: {},
            modalWidth: "500px",
            cComponent: "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
        };
    },
    methods: {
        ...mapActions({
            getScheduleTestList: "testStore/getScheduleTestList"
        }),
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd && crd.tabDetails && crd.tabDetails[this.tab]) {
                this.currentPage = crd.tabDetails[this.tab].page;
                this.orderBy = crd.tabDetails[this.tab].orderBy;
            }
            this.requestGetTestList();
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);

            if (rp.params.resetPage || !crd.routeName) {
                let orderField = this.roleIds.ST === this.user.role_id ? 'test_name' : 'alt_test_name';
                let tabDetail = {
                    Upcoming: {
                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    },
                    Live: {
                        page: 1,
                        orderBy: {
                            field: orderField,
                            order: "ASC"
                        }
                    }
                };
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab || 'Upcoming',
                    tabDetails: tabDetail
                }
                this.setRouteDetails(routeDetails);
            }
            this.defaultData()
        },
        getFormatedDate(date) {
            return moment(date).format("DD/MM/YYYY");
        },
        getFormatedTime(date) {
            return moment(date).format("hh:mm A");
        },
        gotoPastTest(item) {
            // Only navigate for Live tests, not for Upcoming tests
            if (this.tab === 'Live' && this.user.role_id === this.roleIds.ST) {
                // For live tests, navigate to test instructions
                this.$router.push({
                    name: "instructions-about-test",
                    params: {
                        test_id: item.test_id,
                        test_institute_id: item.test_institute_id,
                        test_schedule_id: item.schedule_id
                    }
                });
            } else if (this.tab === 'Upcoming') {
                // Do nothing for upcoming tests - they are not clickable
                return;
            }
        },
        requestGetTestList() {
            // Clear items before loading new data to prevent CSS issues
            this.items = [];

            let reqData = {
                category: this.tab === 'Live' ? 'ONGOING' : 'UPCOMING',
                orderBy: this.orderBy,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
                AITS_LIST: true
            };
            this.$root.showLoader = true;
            this.getScheduleTestList(reqData)
                .then((response) => {
                    if (response.list.length == 0 && this.currentPage != 1 && !this.$route.query.resetPage) {
                        this.onPageChange(1);
                        return;
                    }
                    this.$root.showLoader = false;
                    this.items = response.list;
                    this.totalPages = response.pagination.pageCount;
                    const sharedTestIds = this.items
                        .filter(item => item.is_shared_test === 1)
                        .map(item => ({ id: item.id, is_shared_test: item.is_shared_test }));
                    localStorage.setItem('sharedTestIds', JSON.stringify(sharedTestIds));
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                    this.items = []; // Clear items on error as well
                });
        },
        onPageChange(e) {
            this.currentPage = e;

            // Save the current page to route details for this specific tab
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd && crd.tabDetails && crd.tabDetails[this.tab]) {
                crd.tabDetails[this.tab].page = e;
                this.setRouteDetails(crd);
            }

            this.requestGetTestList();
        },
        onSortChange() {
            // Save the orderBy to route details for this specific tab
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd && crd.tabDetails && crd.tabDetails[this.tab]) {
                crd.tabDetails[this.tab].orderBy = this.orderBy;
                this.setRouteDetails(crd);
            }

            this.requestGetTestList();
        },
        onHeaderAction(e) {
            // Handle header actions if needed
        },
        checkModuleAccess() {
            this.status = this.checkStudentUpgradedHelper(
                this.user.subscription_details, "AITS"
            );
            this.cComponent =
                "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp";
            this.modalWidth = "500px";
            this.alertBoxData = { packageName: "AITS" };
            return this.status;
        },
        onClose(data) {
            this.status = data.status;
        }
    },
    watch: {
        tab(val, oldVal) {
            if (oldVal && val !== oldVal) {
                // Save the selected tab to route details
                let routeName = this.$route.name;
                let crd = this.getCurrentRouteDetails(routeName);
                if (crd) {
                    crd.selectedTab = val;
                    this.setRouteDetails(crd);
                }

                // Use nextTick to ensure DOM is updated before loading data
                this.$nextTick(() => {
                    this.defaultData();
                });
            }
        },
        '$route.name'(val) {
            this.checkSessionData();
        }
    },
    computed: {
        ...mapState("userStore", ["user"])
    }
};
</script>
